import {
  education
} from '../constants';

/**
   * Import constants
   */
const {
  SET_EDUCATION_DATA,
} = education;

const actions = {
  setEducationData: (data) => ({ type: SET_EDUCATION_DATA, data }),
};

// eslint-disable-next-line import/prefer-default-export
export const setEducationData = (modalType) => (dispatch) => {
  dispatch(actions.setEducationData(modalType));
};
